import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import success from "../../../src/waitlistDocVault/assets/images/success.png";
import verification from "../../../src/waitlistDocVault/assets/images/Verification.png";
import failure from "../../../src/waitlistDocVault/assets/images/failure.png";
import { get } from "lodash";
import { postDownloadApi } from "../../shared/service";
import { toast, ToastContainer } from "react-toastify";
import { getThirdPartyData} from "../../waitlist/services/waitlist-service";
import uploadimage from "../../../src/waitlistDocVault/assets/images/uploadimage.png";
import { onboardingService } from "../../shell/services/onboarding";
import PreviewModal from "../../shell/components/onboarding/PreviewModal";
// import { Mixpanel } from "../../waitlist/components/MixPanel";
import { utils } from "../../core/helpers/utils";


export default function KycBankPreview(props) {
  const [pan, setPan] = useState(props?.docs[0]?.pan);
  const [email, setEmail] = useState(props?.docs[0]?.email);
  const [userProfile, setUserProfile] = useState(props.userProfile);
  const [errors, setErrors] = useState(props.errors);
  const [isMobile, setIsMobile] = useState(false);
  const [showUploadDocs, setUploadDocs] = useState(false);
  const [bankDoc, setBankDoc] = useState("");
  const [bankPresent, setBankPresent] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);
  const [bankDocData, setBankDocData] = useState();
  const [uploading, setUploading] = useState([]);
  const [uploaded, setUploaded] = useState([]);
  const [maxFileSizeCheck, setMaxFileSizeCheck] = useState([]);
  const [docTypes, setDocTypes] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [fileData, setFileData] = useState();
  const [uploadedBanks, setUploadedBanks] = useState([]);
  const { setReupload, areAllDocsUploaded } = props;
  const [show, setShow] = useState(false);
  const [bankAddSuccessModal, setBankAddSuccessModal] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [isPdf, setIsPdf] = useState(false);
  const [previewData, setPreViewData] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [product, setProduct] = useState(props?.product);

  useEffect(() => {
    let mobile = window.matchMedia("(max-width: 768px)").matches;
    if (props.userProfile && !props.userProfile.accountNumber) {
      getRecentAccountNumber();
    }
    if (!props?.docs[0]?.pan?.length && !props?.docs[0]?.pan) {
      getUserPanOrEmail('pan');
    }
    if (props?.docs[0]?.email?.length && !props?.docs[0]?.email) {
      getUserPanOrEmail('email');
    }
    setIsMobile(mobile);
  }, []);

  const closePreview = () => {
    setIsPreviewOpen(false);
  };

  const bankSuccessAddedPopUp = () => {
    setBankAddSuccessModal(!bankAddSuccessModal);
    setUploadDocs(!showUploadDocs);
    props.updateDocStatus();
    props.moveNextTab();
  };

  const uploadDocsIndia = (docType, email, pan, doc, fileName) => {
    const formData = new FormData();
    fileName
      ? formData.append("useruploadcandocs", doc, fileName)
      : formData.append("useruploadcandocs", doc);
    formData.append("name", docType);

    const requestOptions = {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {
        "X-product": `orobonds:default`,
        "use-pkey" : false
      }
    };

    return fetch(
      process.env.REACT_APP_REPORTS_API_URL +
        "/users/uploadDocs?email=" +
        email +
        "&pan=" +
        pan +
        "&type=" +
        docType,
      requestOptions
    )
      .then((response) => response.json())
      .then((portfolioResponse) => {
        return portfolioResponse;
      });
  };

  const getUploadedDocsList = (inputPan) => {
    let tmpBankList;
    let tmpDocList;
    onboardingService
      .getOnboardingUserDocState(
        { pan: inputPan })
      .then((result) => {
        const response = utils.parsePayload(result);
        if (!response.data || !response.success) {
          // return toast.error("No documents found.");
        }
        if (response.data && response.data.length) {
          tmpBankList = response.data.filter((x) => x.type === "bank")[0];
          if (tmpBankList) {
            setUploadedBanks(tmpBankList);
            setBankPresent(true);
          }
          areAllDocsUploaded && areAllDocsUploaded(get(response, "data", []));
        }
      });
  };

  const docUpload = (name, file, type) => {
    var tempUploading = uploading;
    var tempUploaded = uploaded;
    var tempDocTypes = docTypes;
    var tempMaxFileSizeCheck = maxFileSizeCheck;

    if (!tempMaxFileSizeCheck || !tempMaxFileSizeCheck.length) {
      let fileListTemp = [...fileList];
      fileListTemp.push(file);

      setFileData(file);
      setFileList(fileListTemp);
      setUploaded(tempUploaded);
      setUploading(tempUploading);

      uploadDocsIndia(type, email, pan, file, name).then((response) => {
        var uploading2 = uploading;
        var uploaded2 = uploaded;

        if (!response || !response.success) {
          if (uploading2.indexOf(name) !== -1) {
            uploading2.splice(uploading.indexOf(name), 1);
          }

          setUploading(uploading2);

          let msg = response && response.error;
          return toast.error(
            msg || "Doc not uploaded, please try after some time"
          );
        }
        getUploadedDocsList(pan);
        if (uploading2.indexOf(name) !== -1) {
          uploading2.splice(uploading.indexOf(name), 1);
        }

        if (uploaded2.indexOf(name) === -1) {
          uploaded2.push(name);
          tempDocTypes.map((doc) => {
            if (doc.type === name) {
              doc.status = "uploaded";
            }
          });
        }
        setUploaded(tempUploaded);
        setUploading(tempUploading);
        setDocTypes(tempDocTypes);
        setShow(true);
        setBankAddSuccessModal(true);
        setConfirm(true);
      });
    }
  };

  const onBankDocUpload = (e) => {
    setBankDoc(e.target.files[0].name);
    setBankDocData(e.target.files[0]);
    confirmDoc(e.target.files[0], 'bank')
  };

  const confirmDoc = (fileData, type) => {
    if (fileData) {
      var name = fileData.name;
      var tempUploading = uploading;
      var tempUploaded = uploaded;
      var tempMaxFileSizeCheck = maxFileSizeCheck;

      if (tempUploading.indexOf(name) === -1) {
        tempUploading.push(name);
      }

      if (tempUploaded.indexOf(name) !== -1) {
        tempUploaded.splice(tempUploaded.indexOf(name), 1);
      }

      if (tempMaxFileSizeCheck.indexOf(name) !== -1) {
        tempMaxFileSizeCheck.splice(tempMaxFileSizeCheck.indexOf(name), 1);
      }

      if (fileData.size > 20000000) {
        var uploading2 = uploading;
        var maxFileSizeCheck2 = maxFileSizeCheck;

        if (uploading2.indexOf(name) !== -1) {
          uploading2.splice(uploading.indexOf(name), 1);
        }

        if (maxFileSizeCheck2.indexOf(name) === -1) {
          maxFileSizeCheck2.push(name);
        }

        setUploading(tempUploading);
        setMaxFileSizeCheck(maxFileSizeCheck2);

        return;
      }

      docUpload(fileData.name, fileData, type);
    }
  };

  const updatePreviewData = () => {    
        let filename = props?.docs[0]?.data;
        getDocs(filename);
        setIsPreviewOpen(true);
  }

  const getDocs = (filename) => {
    const _url = "/users/v2/downloadDocs";
    const payload = {
      filename: filename,
    };
    postDownloadApi(_url, payload).then((fileResponse) => {
      if (!fileResponse || fileResponse.err) {
        toast.error(
          fileResponse.msg || "Not able to fetch data. Please try again"
        );
        return;
      }
      let tempFilenameArr= filename.split('.');
      let ispdf = tempFilenameArr[tempFilenameArr.length - 1] === 'pdf' ? true : false;
      setIsPdf(ispdf);
      setPreViewData(URL.createObjectURL(fileResponse));
    });
  }

  const getRecentAccountNumber = () => {
    let data;
    getThirdPartyData({"X-product": `orobonds:default`, 'x-encrypted-data': true })
      .then((result) => {
        const response = utils.parsePayload(result);
        if (response && response.success && response.data) {
          data = response.data;
          setUserProfile(data);
        }
      });
  };

  const getUserPanOrEmail = (type) => {
    let data;
    getThirdPartyData({"X-product": `orobonds:default`, 'x-encrypted-data': true })
      .then((result) => {
        const response = utils.parsePayload(result);
        if (type === 'pan') {
          if (response && response.success && response.data) {
            data = response?.data?.pan;
            setPan(data);
          }
        }else if (type === 'email') {
          if (response && response.success && response.data) {
            data = response?.data?.email;
            setEmail(data);
          }
        }
      });
  };

  const getBankStatus = () => {
    if (props.isKycDone) {
      return <div className="d-flex align-items-center">
        <p className="mb-0">
          Bank account verified successfully
        </p>
        <img src={success} alt="success-icon-img"/>
      </div>
    }
    if (!errors.length ) { //default
        return <>
        <div className="d-flex align-items-center">
          <p className="mb-0">
            Bank verification is under process
          </p>
          <img src={verification} alt="success-icon-img"/>
        </div>
        </>
    }    
    if (errors.length) {
      return <div className="d-flex align-items-center">
        <p className="mb-0">
          Bank verification failed
        </p>
        <img src={failure} alt="failure-icon-img"/>
      </div>
    } 
  }

  const editBank = () => {
    // Mixpanel.track("cl_edit_bank_docvault");
    setReupload(true);
  }

  const bankPreviewNext = () => {
    /* Mixpanel.track("cl_next_bank_docvault",
      {
        "Email id": props.email ? props.email : ""
      }
    ); */
    props.moveNextTab();
  }

  return(
    <>     
    {!showUploadDocs &&
    <>
      <div className="bank-status d-flex">
        <div className="adress-status text-capitalize">
          {getBankStatus()}
        </div>
      </div>

      {errors &&
        errors.length &&
        errors[0].remarks ?
        (
          <div className="banner d-flex mt-4">
            <p>{errors[0].remarks}</p>
            {/* <span class="mdi mdi-close-circle-outline" ></span> */}
          </div>
        ) : null
      }

      {/* <div className="bank-details">
        <Row className="mt-5">
          <Col lg={6} xs={6} sm={6} className="mb-5">
            <p className="text-muted font-weight-semi-bold font-size-16">Account Holder</p>
            <p className="font-weight-bold font-size-18">
              {userProfile && userProfile.nameInBank ? userProfile.nameInBank : '-'}
            </p>
          </Col>
          <Col lg={6} xs={6} sm={6} className="mb-5">
            <p className="text-muted font-weight-semi-bold font-size-16">Account Number</p>
            <p className="font-weight-bold font-size-18">
              {userProfile && userProfile.accountNumber ? userProfile.accountNumber : '-'}
            </p>
          </Col>
          <Col lg={6} xs={6} sm={6} className="mb-5">
            <p className="text-muted font-weight-semi-bold font-size-16">IFSC Code</p>
            <p className="font-weight-bold font-size-18">
              {userProfile && userProfile.ifscCode ? userProfile.ifscCode : '-'}
            </p>
          </Col>
          <Col lg={6} xs={6} sm={6} className="mb-5">
            <p className="text-muted font-weight-semi-bold font-size-16">Account Type</p>
            <p className="font-weight-bold font-size-18">
              {userProfile && userProfile.accountType ? userProfile.accountType : '-'}
            </p>
          </Col>
          <Col lg={6} xs={6} sm={6} className="mb-5">
            <p className="text-muted font-weight-semi-bold font-size-16">Bank name</p>
            <p className="font-weight-bold font-size-18">
              {userProfile && userProfile.bankName ? userProfile.bankName : '-'}
            </p>
          </Col>
          <Col lg={6} xs={6} sm={6} className="mb-5">
            <p className="text-muted font-weight-semi-bold font-size-16">Branch name</p>
            <p className="font-weight-bold font-size-18">
              {userProfile && userProfile.branchName ? userProfile.branchName : '-'}
            </p>
          </Col>
        </Row>
      </div> */}
      {/* {props?.docs?.[0]?.data.length && props?.docs?.[0]?.data &&
      <>
        {isMobile && !props.isKycDone && (
          <div className="submit text-center mt-3">
            <Button color="secondary" outline onClick={() => setUploadDocs(true)}>Reupload</Button>

            <p className={isMobile ? "mt-3" : "" } 
                style={{marginTop: '20px',
                        fontSize: '18px',
                        color: '#575757',
                        fontWeight: '800',
                        textDecoration: 'underline',
                        cursor: "pointer"
                      }}
                onClick = {updatePreviewData}
            >
              Preview
            </p>
          </div>
        )}
      </>
      } */}
      </>
    }

      {!showUploadDocs &&

        <div className="bank-details">
          <Row className="pt-3 pb-3">
            <Col lg={6} xs={6} sm={6} className="mb-5">
              <p className="text-muted font-weight-semi-bold font-size-16">Account Holder</p>
              <p className="font-weight-bold font-size-18">
                {userProfile && userProfile.nameInBank ? userProfile.nameInBank : '-'}
              </p>
            </Col>
            <Col lg={6} xs={6} sm={6} className="mb-5">
              <p className="text-muted font-weight-semi-bold font-size-16">Account Number</p>
              <p className="font-weight-bold font-size-18">
                {userProfile && userProfile.accountNumber ? userProfile.accountNumber : '-'}
              </p>
            </Col>
            <Col lg={6} xs={6} sm={6} className="mb-5">
              <p className="text-muted font-weight-semi-bold font-size-16">IFSC Code</p>
              <p className="font-weight-bold font-size-18">
                {userProfile && userProfile.ifscCode ? userProfile.ifscCode : '-'}
              </p>
            </Col>
            <Col lg={6} xs={6} sm={6} className="mb-5">
              <p className="text-muted font-weight-semi-bold font-size-16">Account Type</p>
              <p className="font-weight-bold font-size-18">
                {userProfile && userProfile.accountType ? userProfile.accountType : '-'}
              </p>
            </Col>
            <Col lg={6} xs={6} sm={6} className="mb-3">
              <p className="text-muted font-weight-semi-bold font-size-16">Bank name</p>
              <p className="font-weight-bold font-size-18">
                {userProfile && userProfile.bankName ? userProfile.bankName : '-'}
              </p>
            </Col>
            <Col lg={6} xs={6} sm={6} className="mb-3">
              <p className="text-muted font-weight-semi-bold font-size-16">Branch name</p>
              <p className="font-weight-bold font-size-18">
                {userProfile && userProfile.branchName ? userProfile.branchName : '-'}
              </p>
            </Col>
              <div className="btn-container">
                {!props.isKycDone && (
                  <div className="submit text-center">
                    <Button
                      color="secondary"
                      outline
                      onClick={editBank}
                    >
                      Edit
                    </Button>                    
                  </div>
                )}
                <div>
                  <Button
                    className="nxt"
                    onClick={bankPreviewNext}
                    disabled={errors.length}
                  >
                    Next
                  </Button>
                </div>
              </div>
          </Row>          
        </div>
      }

      {showUploadDocs && (
        <div
          className={!isMobile ? "adress-banner border mt-5" : "adress-banner-mob border mt-3"}
          style={{width: !isMobile ? 'max-content' : 'auto', margin: 'auto'}}
        >
          <div className="d-flex flex-column align-items-center">
            <p className="font-size-18 font-weight-semi-bold">
              Upload Bank Proof to verify
            </p>
            <p>Please upload a photo of any one of the following</p>
            <ol className="text-left">
              <li>Cancelled cheque</li>
              <li>Bank statement</li>
              <li>Passbook first page</li>
            </ol>
            <label>
              <div className="text-center upload-front mt-2 mb-3">
                <img className="mt-2" src={uploadimage} alt="uploaded-icon"/>
                {bankDoc || bankPresent ? (
                  <h6 className="text-muted p-2 mt-3">
                    Reupload your bank statement
                  </h6>
                ) : (
                  <h6 className="text-muted p-2 mt-3">
                    Upload your bank statement
                    <span style={{ color: "red" }}>*</span>
                  </h6>
                )}
                <input
                  type="file"
                  id="upload"
                  name="bank"
                  style={{ display: "none" }}
                  onChange={(e) => onBankDocUpload(e)}
                  className="doc-input"
                  accept=".png, .pdf, .jpg, .jpeg, video/*"
                />
              </div>
            </label>
            <Button color="secondary" onClick={() => setUploadDocs(!showUploadDocs)}>
              Back
            </Button>
          </div>
        </div>
      )}

      {isPreviewOpen ?
        <PreviewModal
          close={closePreview}
          isOpen={isPreviewOpen}
          preview={previewData}
          isPdf={isPdf}
          centered
        />
      : null }

      <Modal
        centered
        isOpen={bankAddSuccessModal}
        toggle={bankSuccessAddedPopUp}
        className="modal-md"
      >
        <ModalHeader
          toggle={bankSuccessAddedPopUp}
          className="pt-3"
        ></ModalHeader>
        <ModalBody className="text-center bse p-3">
          {successMsg ?
            <>
              <img src={verification} alt="" />
              <div className="font-size-12 font-weight-bold">
              {successMsg}
              </div>
            </> :
            <>
              <img src={success} alt="" />
              <div className="font-size-30 font-weight-bold">Congratulations!</div>
              <div className="font-size-12 font-weight-bold">
                Your bank proof has been uploaded successfully!
              </div>
            </>
          }
        </ModalBody>
      </Modal>
      <ToastContainer />
    </>
  )
}
